var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginfordy"},[_c('loadJs',{on:{"loadJsOk":_vm.onLoadSdked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }